import { Box, Button, useDisclosure } from "@chakra-ui/react";
import TopupTable from "./components/TopupTable";
import { useHistory } from "react-router-dom";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { ConfirmDeleteModal } from "components/modal/ConfirmDeleteModal";
import { MdAdd } from "react-icons/md";
import { Topup } from "./components/Topup";
import { EditTopup } from "./components/EditTopup";

export function TopUpHistory() {
    const [topupData, setTopupData] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const { isOpen: isAddOpen, onOpen: onAddOpen, onClose: onAddClose } = useDisclosure();
    const { isOpen: isDelOpen, onOpen: onDelOpen, onClose: onDelClose } = useDisclosure();
    const { isOpen: isEditOpen, onOpen: onEditOpen, onClose: onEditClose } = useDisclosure();
    const [agentData, setAgentData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [token, setToken] = useState();
    const [creator, setCreator] = useState('');
    const [role, setRole] = useState();

    let navigate = useHistory();

    useEffect(() => {
        const clientInfo = sessionStorage.getItem('clientInfo');
        const key = sessionStorage.getItem('token');

        if (clientInfo) {
            const { agentId, clientName, role } = JSON.parse(clientInfo);
            setRole(role);
            /* if (role === 'User') {
                navigate.push('/auth');
            } */
            setCreator(clientName);
            setToken(key);

            getTopupHistory(key, role, agentId);
            getAgents(key);
        }
        else
            navigate.push('/auth');
    }, []);

    const getTopupHistory = async (key, urole = null, agentId = null) => {
        try {
            setIsloading(true);

            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }
            let params = null;
            let response = null;
            let type = 'topup-hist';

            if (urole) {
                if (urole === 'User') {
                    params = {
                        agentId
                    };
                    type = 'topup-hist-client';
                    response = await axios.post(getAPIEndpoint(type), params, apiHeader);
                }
                else {
                    response = await axios.get(getAPIEndpoint(type), apiHeader);
                }
            }
            else {
                response = await axios.get(getAPIEndpoint(type), apiHeader);
            }

            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setTopupData(data);
                }
                else
                    setTopupData([]);
            }
        } catch (error) {
            await logger({ task: "Get Topup History", error: error.toString() });
        }
        setIsloading(false);
    }

    const getAgents = async (key) => {
        try {
            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.get(getAPIEndpoint('agent'), apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setAgentData(data);
                }
                else {
                    setAgentData([]);
                }
            }

        } catch (error) {
            await logger({ task: "Get Agents", error: error.toString() });
        }
    }

    const deleteFn = (row) => {
        setSelectedRow(row);
        onDelOpen();
    }

    const editFn = (row) => {
        setSelectedRow(row);
        onEditOpen();
    }

    const deleteTopup = async (key) => {
        try {
            setIsDeleting(true);

            const apiHeader = {
                headers: {
                    "authorization": `Bearer ${key}`
                }
            }

            const response = await axios.post(getAPIEndpoint('topup-delete'), { id: selectedRow.id, creator }, apiHeader);
            if (response) {
                const { status } = response.data;
                if (status === 'success') {
                    await getTopupHistory(key);
                    onDelClose();
                }
                else {
                    toast.error('Sorry, we are unable to delete top-up entry at this time. Please try again later.');
                }
            }
        } catch (error) {
            await logger({ task: "Delete Top-up", error: error.toString() });
        }
        setIsDeleting(false);
    }

    const showTopupDialog = () => {
        onAddOpen();
    }

    const modalProps = {
        isOpen: isAddOpen,
        onClose: onAddClose,
        refreshData: getTopupHistory,
        clients: agentData,
        creator,
        authKey: token
    }

    const props = {
        isLoading,
        data: topupData,
        addControl: <Button
            fontSize={{ base: "12px", md: "15px" }}
            color={"white"}
            bg={"#0C7FE9"}
            _hover={{
                bg: "#3c98ed"
            }}
            w={'120px'}
            h={'45px'}
            leftIcon={<MdAdd size={"22px"} />}
            onClick={showTopupDialog}
        >
            Top up
        </Button>,
        deleteFn,
        editFn,
        disableDelete: role === 'User' ? true : false,
        disableEdit: role === 'User' ? true : false,
        disableAdd: role === 'User' ? true : false
    }

    const modalPropsDel = {
        isOpen: isDelOpen,
        onClose: onDelClose,
        deleteFn: deleteTopup,
        tag: 'top-up',
        isDeleting,
        authKey: token
    }

    const modalPropsEdit = {
        isOpen: isEditOpen,
        onClose: onEditClose,
        topupData: selectedRow,
        refreshData: getTopupHistory,
        clients: agentData,
        creator,
        authKey: token
    }

    return (
        <>
            <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                <TopupTable {...props} />
                <Topup {...modalProps} />
                {selectedRow && <ConfirmDeleteModal {...modalPropsDel} />}
                {selectedRow && <EditTopup {...modalPropsEdit} />}
            </Box>
            <ToastContainer />
        </>

    )
}